import * as React from "react"
import AppBar from "@mui/material/AppBar"
import Box from "@mui/material/Box"
import Toolbar from "@mui/material/Toolbar"
import { Badge, Drawer, Grid, IconButton, Typography } from "@mui/material"
import Sidebar from "../sidebar/Sidebar"
import "./Navbar.css"
import { ReactComponent as SmallAppLogo } from "../../assests/images/logo_small.svg"
import { getUserType } from "../../utils/util"
import MenuIcon from "@mui/icons-material/Menu";
import { useAuthContext } from "../../context/AuthContext"

export default function Navbar() {
  const [userEmail, setUserEmail] = React.useState("")
  const [userType, setUserType] = React.useState("")
  const [isDrawerOpen, setIsDrawerOpen] = React.useState(false);
  const originalUser = JSON.parse(localStorage.getItem('original_user') as string);

  const { feedbackCount, isImpersonating, impersonatedUser } = useAuthContext()

  // Function to toggle the drawer
  const toggleDrawer = () => {
    setIsDrawerOpen((prevValue) => !prevValue);
  };

  React.useEffect(() => {
    if (isImpersonating && impersonatedUser) {
      setUserEmail(impersonatedUser?.email || "")
      setUserType(impersonatedUser?.userType || "")
    }
    else if (localStorage.getItem("user")) {
      const userDataString = localStorage.getItem("user") as string;
      const userData = JSON.parse(userDataString)
      setUserEmail(userData?.email)
      setUserType(userData?.user_type)
   }
  }, [isImpersonating, impersonatedUser])

  return (
    <>
      <Box>
        <AppBar position="fixed" sx={{background: "#FFFFFF", height: "100px", justifyContent: "center", zIndex: (theme) => theme.zIndex.drawer + 1 }}>
          <Toolbar sx={{justifyContent: "space-between"}}>
            <Box display={"flex"}>
              <IconButton
                color="default"
                aria-label="open drawer"
                edge="start"
                onClick={toggleDrawer}
                sx={{ display: { md: 'none' }, mt: "5px", paddingRight: 0 }}
              >
                {
                  feedbackCount > 0 ?
                    <Badge badgeContent={feedbackCount} color="error">
                      <MenuIcon />
                    </Badge>
                    :
                    <MenuIcon />
                }
              </IconButton>
              <SmallAppLogo />
            </Box>
            <div>
            {isImpersonating && (
              <Typography sx={{ color: "black", fontWeight: "bold", wordBreak: { xs: "break-word"} }}>
                Logged In User:
              </Typography>
            )}
              <Typography sx={{ color: "black", fontWeight: "bold", wordBreak: { xs: "break-word"} }}>
                  {originalUser?.email}
              </Typography>
              <Typography sx={{ color: "black" }}>
                  {getUserType(Number(originalUser?.user_type))}
              </Typography>
            </div>
            {isImpersonating && (
              <div style={{ backgroundColor: "#140A9A", padding: "10px", borderRadius: "5px" }}>
                <Typography sx={{ color: "white", fontWeight: "bold", wordBreak: { xs: "break-word"} }}>
                  Impersonating User:
                </Typography>
                <Typography sx={{ color: "white", fontWeight: "bold", wordBreak: { xs: "break-word"} }}>
                  {userEmail}
                </Typography>
                <Typography sx={{ color: "white" }}>
                  {getUserType(Number(userType))}
              </Typography>
              </div>
            )}
          </Toolbar>
        </AppBar>
        <Box
          component="nav"
          sx={{ width: { sm: 220 }, flexShrink: { sm: 0 } }}
        >
          {/* Mobile drawer */}
          <Drawer
            variant="temporary"
            open={isDrawerOpen}
            onClose={toggleDrawer}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
            sx={{
              display: { xs: 'block', md: 'none' },
              '& .MuiDrawer-paper': { boxSizing: 'border-box', width: 220 },
            }}
          >
            <Sidebar />
          </Drawer>
          {/* Desktop drawer */}
          <Drawer
            variant="permanent"
            sx={{
              display: { xs: 'none', md: 'block' },
              '& .MuiDrawer-paper': { boxSizing: 'border-box', width: 220 },
            }}
            open
          >
            <Sidebar />
          </Drawer>
      </Box>
      </Box>
    </>
  )
}
